import { collapseSection, expandSection } from '../src/Helpers';

export default {
  props: {
    defaultTab: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentTab: this.defaultTab,
    };
  },

  methods: {
    isTabActive(tabName) {
      return this.currentTab === tabName;
    },

    setTab(tabName) {
      this.currentTab = tabName;
    },

    toggleMobileTabsMenu() {
      let expandButton = this.$el.querySelector('.expand-button');
      let mobileTabsMenu = this.$el.querySelector('.expand-list');

      if (!expandButton.classList.contains('is-active')) {
        expandSection(mobileTabsMenu);
        expandButton.classList.add('is-active');
      } else if (expandButton.classList.contains('is-active')) {
        collapseSection(mobileTabsMenu);
        expandButton.classList.remove('is-active');
      }
    },
  },

  render() {
    return this.$scopedSlots.default({
      currentTab: this.currentTab,
      isTabActive: this.isTabActive,
      toggleMobileTabsMenu: this.toggleMobileTabsMenu,
      setTab: this.setTab,
    });
  },
};
